import { render, staticRenderFns } from "./addappMg.vue?vue&type=template&id=8ff8e52a&scoped=true&"
import script from "./addappMg.vue?vue&type=script&lang=js&"
export * from "./addappMg.vue?vue&type=script&lang=js&"
import style0 from "./addappMg.vue?vue&type=style&index=0&id=8ff8e52a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff8e52a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ff8e52a')) {
      api.createRecord('8ff8e52a', component.options)
    } else {
      api.reload('8ff8e52a', component.options)
    }
    module.hot.accept("./addappMg.vue?vue&type=template&id=8ff8e52a&scoped=true&", function () {
      api.rerender('8ff8e52a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/googleAds/components/addappMg.vue"
export default component.exports